/**
 * Watch API client — functions for watching/unwatching resources.
 */

import * as api from '../services/api-client';

export type WatchResourceType = 'board' | 'card' | 'library' | 'page';

export interface WatchStatus {
  readonly watching: boolean;
}

export interface WatchItem {
  readonly resourceType: WatchResourceType;
  readonly resourceId: string;
  readonly resourceTitle: string;
  readonly createdAt: string;
}

// ---------------------------------------------------------------------------
// Watch / Unwatch / Status
// ---------------------------------------------------------------------------

function buildPath(resourceType: WatchResourceType, resourceId: string, parentId?: string): string {
  switch (resourceType) {
    case 'board':
      return `/v1/boards/${encodeURIComponent(resourceId)}/watch`;
    case 'card':
      return `/v1/boards/${encodeURIComponent(parentId!)}/cards/${encodeURIComponent(resourceId)}/watch`;
    case 'library':
      return `/v1/libraries/${encodeURIComponent(resourceId)}/watch`;
    case 'page':
      return `/v1/pages/${encodeURIComponent(resourceId)}/watch`;
  }
}

export async function watch(resourceType: WatchResourceType, resourceId: string, parentId?: string): Promise<WatchStatus> {
  return api.post<WatchStatus>(buildPath(resourceType, resourceId, parentId));
}

export async function unwatch(resourceType: WatchResourceType, resourceId: string, parentId?: string): Promise<WatchStatus> {
  await api.del(buildPath(resourceType, resourceId, parentId));
  return { watching: false };
}

export async function getWatchStatus(resourceType: WatchResourceType, resourceId: string, parentId?: string): Promise<WatchStatus> {
  return api.get<WatchStatus>(buildPath(resourceType, resourceId, parentId));
}

// ---------------------------------------------------------------------------
// My Watches
// ---------------------------------------------------------------------------

export async function listMyWatches(): Promise<{ data: WatchItem[] }> {
  return api.get<{ data: WatchItem[] }>('/v1/users/me/watches');
}
